module.exports = "/images/hsbc.svg?363889a445633530037ce41e404d7a54";